__turbopack_context__.v({
  "blurb": "l2DICa_blurb",
  "buttonRow": "l2DICa_buttonRow",
  "container": "l2DICa_container",
  "fakePaper": "l2DICa_fakePaper",
  "fakePaperTop": "l2DICa_fakePaperTop",
  "loading": "l2DICa_loading",
  "tabPanel": "l2DICa_tabPanel",
});
